<template>
  <div
    id="app"
    :class="{ noRoute: $route.path == '/function' || $route.meta.hidden }"
  >
    <navigator id="nav" />
    <div class="router-wrap">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <foot id="foot" />
  </div>
</template>
<script>
import navigator from "@/components/HelloWorld";
import foot from "@/components/footer";
export default {
  components: { navigator, foot },
  created() {
    console.log(this.$route);
  },
};
</script>
<style lang="less">
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
:root {
  -theme-color: #42aab2;
}
html {
  position: static;
  min-width: 1200px;
}
html,
body {
  margin: 0;
  padding: 0;
}
#app.noRoute {
  #nav,
  #foot {
    display: none  !important;
  }
  .router-wrap{
    margin-top: 0;
  }
}
ul {
  margin: 0;
  list-style: none;
}
p,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}
.router-wrap {
  margin-top: 88px;
}
.wrap {
  width: 1200px;
  margin: 0 auto;
}
.public-title {
  text-align: center;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  letter-spacing: 1px;
  position: relative;
}
.public-title::after {
  content: attr(content);
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #d9d9d9;
  position: absolute;
  left: 50%;
  transform: translate(-50%, -6px);
  opacity: 0.3;
  top: 0;
}
.other-banner {
  width: 100%;
}
.el-pagination {
  text-align: center;
}
.btn-prev,
.btn-next {
  padding-left: 10px !important;
  padding-right: 10px !important;
  border: 1px solid #42aab2 !important;
  border-radius: 2px !important;
  color: #42aab2 !important;
}
.el-pager .number {
  margin: 0 5px;
  border: 1px solid #42aab2 !important;
  border-radius: 2px !important;
  color: #42aab2 !important;
}
.el-pager li:hover {
  color: #42aab2 !important;
}
.el-pager .number.active {
  background: #42aab2 !important;
  color: white !important;
  font-size: 13px;
  font-family: PingFang SC;
  font-weight: bold;
}
@media (min-width: 881px) {
  .mobile {
    display: none !important;
  }
}
@media (max-width: 760px) {
  .pc {
    display: none !important;
  }
  html {
    min-width: unset;
  }
  .wrap {
    width: unset;
  }
  .router-wrap {
    margin-top: 1rem;
    min-height: calc(100vh - 1rem);
  }
  .public-title {
    font-size: 0.2rem;
  }
  .public-title::after {
    font-size: 0.36rem;
  }
  .other-banner {
    height: 2.5rem;
    object-fit: cover;
    vertical-align: middle;
  }
  .more {
    text-align: center;
    font-size: 0.25rem;
    margin: 0.5rem 0;
  }
  .more:active,
  .more:hover {
    opacity: 0.78;
  }
}
</style>
